// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const CalloutContract = contract({
  name: "Callout",
  description: "Inline, ambient, non-blocking status/feedback that sits inside the layout flow. Form-level validation summaries, settings-page notices, page-level banners. NOT a toast (use Sonner for transient). NOT a modal (use Dialog when the user must respond). Put an icon as first child — it's auto-positioned; CalloutTitle + CalloutDescription follow.",
  import: "@gradeui/ui",
  aliases: ["callout","banner","notice","inline alert","in-app notification","status banner","info banner","info callout","warning callout","success callout"],
  subcomponents: ["CalloutTitle","CalloutDescription"],
  element: "div",
  composesWith: ["lucide-react icons as first child","Button (inside CalloutDescription)","Card (as a section callout)"],
  styleDefaults: {"CalloutTitle":"mb-1 text-sm font-semibold leading-snug","CalloutDescription":"text-sm [&_p]:leading-relaxed"},
  props: {
  "variant": {
      schema: z.enum(["default", "destructive", "success", "warning", "info"]).optional(),
      design: "knob",
      description: "semantic colouring; `default` is neutral",
  },
  },
});
